import features from '../config/features';
import type from './mutations-types';
import { FeatureStateShape, RootStateShape } from 'store';
import { ActionTree } from 'vuex';

export default {
	getFeatures: ({ commit }) => {
		commit(type.ADD_FEATURES, features);
	}
} as ActionTree<FeatureStateShape, RootStateShape>;
